import type { ReactNode } from 'react'
import type { ClubInfo } from '../../types/captain'

interface Props {
  club: ClubInfo
  role: 'captain' | 'organizer'
  userName?: string
  onSignOut?: () => void
  children: ReactNode
}

export default function PortalShell({ club, role, userName, onSignOut, children }: Props) {
  return (
    <>
      <header
        className="cp-header-wrap"
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          background: 'rgba(12,12,12,0.78)',
          backdropFilter: 'blur(8px)',
          borderBottom: '0.5px solid rgba(244,242,242,0.06)',
          padding: '20px 40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 24,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, minWidth: 0, flex: 1 }}>
          <img
            src="/full-logo.svg"
            alt="Stazon"
            width={67}
            height={20}
            style={{ width: 'auto', display: 'block', flexShrink: 0 }}
          />
          <div
            className="cp-header-sep"
            style={{
              width: 1,
              height: 18,
              background: 'rgba(244,242,242,0.18)',
              flexShrink: 0,
            }}
            aria-hidden
          />
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <span
              className="cp-header-eyebrow"
              style={{
                fontFamily: "'Helvetica Neue', 'HelveticaNeue', Helvetica, 'Inter', Arial, sans-serif",
                fontSize: 10,
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: '0.12em',
                color: 'rgba(198,196,185,0.55)',
              }}
            >
              Captain Recruitment
            </span>
            <span
              style={{
                fontFamily: "'Lora', Georgia, serif",
                fontStyle: 'italic',
                fontSize: 15,
                fontWeight: 500,
                color: '#F4F2F2',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {club.name}
            </span>
          </div>
        </div>

        <div className="cp-header-user" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div className="cp-header-user-meta" style={{ textAlign: 'right' }}>
            <div
              style={{
                fontFamily:
                  "'Helvetica Neue', 'HelveticaNeue', Helvetica, 'Inter', Arial, sans-serif",
                fontSize: 10,
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: '0.12em',
                color: 'rgba(198,196,185,0.55)',
              }}
            >
              {role === 'organizer' ? 'Organizer' : 'Captain'}
            </div>
            <div
              style={{
                fontFamily:
                  "'Helvetica Neue', 'HelveticaNeue', Helvetica, 'Inter', Arial, sans-serif",
                fontSize: 13,
                fontWeight: 500,
                color: '#F4F2F2',
                whiteSpace: 'nowrap',
              }}
            >
              {userName}
            </div>
          </div>
          <button
            onClick={onSignOut}
            className="cp-btn-ghost"
            style={{ padding: '7px 12px', whiteSpace: 'nowrap' }}
          >
            Sign out
          </button>
        </div>
      </header>

      <main
        className="cp-shell-inner"
        style={{
          maxWidth: 1120,
          margin: '0 auto',
          padding: '48px 40px 120px',
          position: 'relative',
          zIndex: 1,
        }}
      >
        {children}
      </main>
    </>
  )
}
